// extracted by mini-css-extract-plugin
export default {"oneitem":"OneSupportDocument_oneitem__Q6xeL","onetoolbar":"OneSupportDocument_onetoolbar__BQr+R","lbl":"OneSupportDocument_lbl__XAXoh","modal":"OneSupportDocument_modal__GIlti"};